var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPricingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.731,
    height: 17.177,
    viewBox: "0 0 15.731 17.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#22313f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.6,5.608,32.23,6.982V3.8L28.432,0H20.71V15.534h4.643l-.48,1.643,4.009-1.17.471-.473H32.23V12.658l4.212-4.21Zm-4.862-3.82,1.7,1.7h-1.7Zm-2.7,11.38-.384,1.318h-3.9V1.047h5.934V4.538h3.491V8.029l-.659.659h0l-4.436,4.438h0Zm2.288,1.909-1.917.559.559-1.917,4.912-4.91,1.358,1.358Zm4.294-7.009.977-.979L34.96,8.448l-.979.977Z",
    transform: "translate(-20.71)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.009,56.851v-1.98a2.646,2.646,0,0,1,1.165.506.416.416,0,0,0,.231.073.484.484,0,0,0,.484-.478.43.43,0,0,0-.124-.3A2.967,2.967,0,0,0,64,53.959V53.3a.343.343,0,0,0-.343-.343h-.012a.349.349,0,0,0-.354.344v.64a2.039,2.039,0,0,0-2.127,1.913c0,1.277,1.086,1.632,2.127,1.913v2.251a2.92,2.92,0,0,1-1.491-.658.47.47,0,0,0-.281-.1.489.489,0,0,0-.454.5.43.43,0,0,0,.124.3,3.316,3.316,0,0,0,2.108.85v.631a.349.349,0,0,0,.365.331.343.343,0,0,0,.343-.343v-.63a2.014,2.014,0,0,0,2.155-2.025C66.162,57.538,65.05,57.132,64.009,56.851Zm-.709-.18c-.613-.18-1.091-.365-1.091-.889s.433-.9,1.092-.951Zm.709,3.353V57.976c.636.18,1.131.422,1.125,1.012,0,.428-.292.934-1.125,1.035Z",
    transform: "translate(-59.659 -50.104)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPricingIcon);
export default __webpack_public_path__ + "static/media/edit-pricing-icon.8a78d1387aa21a68b4c57c5b7aa77a36.svg";
export { ForwardRef as ReactComponent };